var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCotizacionesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#663ea8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_22",
    "data-name": "Capa 22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.5,9.89a1,1,0,0,0-.42.86.78.78,0,0,0,.24.61,1.61,1.61,0,0,0,.6.36l.1,0V9.64A2.08,2.08,0,0,0,10.5,9.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.28,3.5H14.23a2.86,2.86,0,0,0-5.46,0h-4a1.58,1.58,0,0,0-.38,0,1.85,1.85,0,0,0-1,.55,2,2,0,0,0-.42.64,2,2,0,0,0-.15.77v14a2,2,0,0,0,.57,1.42,1.85,1.85,0,0,0,1,.55,2.34,2.34,0,0,0,.38,0H18.28a2,2,0,0,0,1.93-2V5.5A2,2,0,0,0,18.28,3.5ZM11.5,3.1h0a.67.67,0,1,1-.65.68v0A.66.66,0,0,1,11.5,3.1Zm2.42,12.74a3,3,0,0,1-1.71.79v.72a.62.62,0,0,1-.16.43.61.61,0,0,1-.43.17.59.59,0,0,1-.42-.17.58.58,0,0,1-.16-.43v-.7a5.42,5.42,0,0,1-1.27-.27,3.56,3.56,0,0,1-1.07-.57.55.55,0,0,1-.2-.23.57.57,0,0,1-.06-.31.76.76,0,0,1,.14-.43.43.43,0,0,1,.33-.18.52.52,0,0,1,.21,0l.26.13a4.09,4.09,0,0,0,1,.5,4.56,4.56,0,0,0,.62.13V13.11a10.87,10.87,0,0,1-1.1-.36A2.41,2.41,0,0,1,9,12.07a1.79,1.79,0,0,1-.39-1.24,2.1,2.1,0,0,1,.67-1.58A3,3,0,0,1,11,8.44V7.71a.59.59,0,0,1,.16-.43.54.54,0,0,1,.42-.16.56.56,0,0,1,.43.16.64.64,0,0,1,.16.43v.71a3.93,3.93,0,0,1,2,.84.66.66,0,0,1,.13,1,.41.41,0,0,1-.33.19.45.45,0,0,1-.2,0,.82.82,0,0,1-.26-.14,4.55,4.55,0,0,0-.89-.49,2.2,2.2,0,0,0-.44-.12v2.46a9.72,9.72,0,0,1,1.08.35,2.27,2.27,0,0,1,.9.66,1.8,1.8,0,0,1,.38,1.2A2.11,2.11,0,0,1,13.92,15.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.29,13.47l-.09,0v2a2,2,0,0,0,.47-.2,1,1,0,0,0,.42-.86.68.68,0,0,0-.23-.54A1.64,1.64,0,0,0,12.29,13.47Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCotizacionesActive);
export default __webpack_public_path__ + "static/media/ic-cotizaciones-active.a922ae77316c03ada8d0d6c66a903c2e.svg";
export { ForwardRef as ReactComponent };